module.exports = __webpack_public_path__ + "media/images/logos/youtube-f042f598824884b5c96259176bf6602d.svg";